import styled from 'styled-components';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';

export const StyledPortfolioReturns = styled(Box)({
  display: 'flex',
  position: 'absolute',
  top: '50%',
  transform: 'translateY(-50%)',
  width: '100%',
  pointerEvents: 'none',
});
